import type { ProLayoutProps } from '@ant-design/pro-components';
import 'moment/locale/es';

// Use a relaxed type for Settings to allow custom runtime fields
const Settings: any = {
  navTheme: 'light',
  colorPrimary: '#1976D2',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  colorWeak: false,
  title: 'CRM',
  // Leer desde variables de entorno cuando estén disponibles (UMI_APP_API_URL)
  apiUrl: process.env.NODE_ENV === 'production'
    ? process.env.UMI_APP_API_URL || 'https://apicrm.dsx.com.co'
    : 'https://apicrm.dsx.com.co',
  // Lo de SIESA se quito de aqui: el navegador ya no habla con apiSiesa,
  // va por el proxy del servidor del CRM (src/services/SiesaProxy.ts).
  // Disable PWA SW caching to avoid stale frontend bundles in production deploys
  pwa: false,
  logo: false,
  pageTitleRender: false,
  breadcrumbRender: false,
  iconfontUrl: '',
  token: {
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f5f5f5',
    zIndexPopupBase: 9999,
    zIndexBase: 1000,
  },
  collapsedWidth: 0,
  siderWidth: 256,
  headerHeight: 48,
  splitMenus: false,
  fixSiderbar: true,
  
};

export default Settings;
